module.exports = __webpack_public_path__ + "static/media/img4.92a31d61.png";